<template>
    <el-form v-if="validate" :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left"
             label-width="150px"
             class="demo-ruleForm login-container">
        <h3 class="title">Register</h3>
        <el-form-item label="Role">
            <el-input type="text" v-model="ruleForm2.role" auto-complete="off" placeholder="Role"
                      :disabled="true"></el-input>
        </el-form-item>
        <el-form-item prop="username" label="UserName">
            <el-input type="text" v-model="ruleForm2.username" auto-complete="off" placeholder="UserName"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="Password">
            <el-input type="password" v-model="ruleForm2.password" auto-complete="off"
                      placeholder="Password"></el-input>
        </el-form-item>
        <el-form-item prop="rePassword" label="Confirm Password">
            <el-input type="password" v-model="ruleForm2.rePassword" auto-complete="off"
                      placeholder="Confirm Password"></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="laoding">
                Register
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {login, validateRegister, register} from '../api/securityService';

    let inviteId = "";
    let validate = false;
    export default {
        data() {
            return {
                validate: validate,
                laoding: false,
                ruleForm2: {
                    inviteId: inviteId,
                    role: "",
                    username: '',
                    password: '',
                    rePassword: ''
                },
                rules2: {
                    username: [
                        {required: true, message: 'Please enter username', trigger: 'blur'}
                        //{ validator: validaePass }
                    ],
                    password: [
                        {required: true, message: 'Please enter password', trigger: 'blur'}
                        //{ validator: validaePass2 }
                    ],
                    rePassword: [
                        {required: true, message: 'Please confirm password', trigger: 'blur'},
                        {validator: this.validatePassword, trigger: 'blur'}
                    ]
                },
                checked: true
            };
        },
        methods: {
            validatePassword(rule, value, callback) {
                if (this.ruleForm2.password !== this.ruleForm2.rePassword) {
                    callback(new Error('Password not match.'));
                } else {
                    callback();
                }
            },
            submitRegister() {


            },
            handleSubmit(ev) {
                let _this = this;
                this.$refs.ruleForm2.validate((valid) => {
                    if (valid) {
                        this.laoding = true;
                        let params = {
                            userName:this.ruleForm2.username,
                            password:this.ruleForm2.password,
                            inviteId:this.ruleForm2.inviteId
                        };
                        register(params).then(data=>{
                            this.laoding = false;
                            if (data.status === 200) {
                                this.$message.success("Regist Success.");
                                setTimeout(()=>{
                                    this.$router.push({path: "/login"});
                                },3000);
                            }else{
                                this.$message.error(data.message);
                            }
                        }).catch(error => {
                            this.laoding = false;
                            console.log(error);
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        created() {
            let query = this.$route.query;
            if (!query.id) {
                this.$router.push({path: "/login"});
            } else {
                this.ruleForm2.inviteId = query.id;
                validateRegister({id: this.ruleForm2.inviteId}).then(data => {
                    if (data.status === 200) {
                        this.validate = true;
                        this.ruleForm2.role = data.result.roleName;
                    } else {
                        this.validate = false;
                        setTimeout(() => {
                            this.$router.push({path: "/login"});
                        }, 3000);
                        this.$message.error(data.message);
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        }
    }

</script>

<style lang="scss" scoped>
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 600px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;

        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }

        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// register.vue?4d39dc97